import * as styles from "./Footer.module.css";
import logoBlack from "../../assets/webp/logo-black.webp";
import { CTA } from "../CTA/CTA";
import { useState } from "react";

const Footer = () => {
  const [ctaStatus, setCtaStatus] = useState<"idle" | "success" | "error">(
    "idle"
  );

  return (
    <>
      <footer className={styles.footerContainer}>
        <div className={styles.returnsLogo}>
          <img src={logoBlack} alt="Returns Logo" />
        </div>
        <div className={styles.contactCTA}>
          <div className={styles.contactParent}>
            <p className={styles.returnsDetailsFooter}>
              Returns is an all in one app that let’s you diversify into
              multi-asset investments, protect your wealth and provide
              institutional level infrastructure & tools.
            </p>
            <div className={styles.footerContact}>
              <span>
                <i className="ri-mail-send-line"></i>
                <a href="mailto:support@returns.trade">support@returns.trade</a>
              </span>
              <span>
                <i className="ri-phone-line"></i>
                <a href="tel:+917669428166">+91-76694 28166</a>
              </span>
            </div>
          </div>
          <div className={styles.CTA}>
            {/* <hr className={`${styles.footerLine} ${styles.hr1}`} /> */}
            <span className={styles.CTADesc}>Get a callback!</span>
            <CTA variant="small" status={ctaStatus} setStatus={setCtaStatus} />
          </div>
        </div>
        <hr className={`${styles.footerLine}`} />
        <div className={styles.importantLinksCopyright}>
          <div className={styles.importantLinks}>
            <span>
              <a
                href="https://docs.google.com/document/u/0/d/107oGESPJbd231S9_EKlYOFqG6jjUkrGcJDBCD8wKW_4/mobilebasic?pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & conditions
              </a>
            </span>
            <span>
              <a
                href="https://docs.google.com/document/u/5/d/10_9GANOQ1rBtdjlIKuaRwco_TikyA9WAdAna0hodylg/mobilebasic"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy policy
              </a>
            </span>
            <span>
              <a
                href="https://docs.google.com/document/d/15fbRIZHwOLvguDbm4cf7kG1LOacvaWJ5x5OeKl0Q94E/mobilebasic"
                target="_blank"
                rel="noopener noreferrer"
              >
                Disclaimers
              </a>
            </span>
            <span>
              <a
                href="https://docs.google.com/document/d/14qSyH2Oy6bYxSRZl4twWTuTpaDOgCpXRRpmWLdPRHP8/mobilebasic"
                target="_blank"
                rel="noopener noreferrer"
              >
                Grievances
              </a>
            </span>
          </div>
          {/* <hr className={`${styles.footerLine} ${styles.hr2}`} /> */}
          <div className={styles.legalitiesParent}>
            <div className={styles.copyrightLicence}>
              {/* <hr className={`${styles.footerLine} ${styles.hr3}`} /> */}
              <div>
                ©Copyright {new Date().getFullYear()} Rathi Equity Research All Rights Reserved
              </div>
              {/* <div>License: VBUBCSDNCLAKSCLAKCL1028EU18</div> */}
            </div>
          </div>
        </div>

        <div className={styles.extraDetails}>
          <p>
            Returns is a product of Rathi Equity Research,
            serving as a technology platform that connects users with
            SEBI-registered professionals. Returns does not provide direct
            financial advice or recommendations, and all investment decisions
            are made at the user's discretion and risk. Returns operates as an
            Authorized Person (AP) of Enrich Financial Market Pvt Ltd (SEBI
            Registration Number: INZ000078632), a SEBI-registered broker. The
            term "Returns" solely refers to the product name and does not imply
            or guarantee any financial returns or profits. Research services,
            including those offered by SEBI-registered Research Analyst
            Krishnkanth Rathi (INH000014492), are independent and comply with
            regulatory oversight. Subscription payments for these services are
            made directly to licensed entities or individuals. Past performance
            is not indicative of future results, and Returns is not responsible
            for any losses arising from recommendations made by SEBI-registered
            professionals.
          </p>

          <p>
            For any inquiries, contact us at Phone: +91-76694 28166 or Grievance
            Officer: grievance@returns.trade. Our registered address is 315,
            Galleria Tower, Galleria Market, DLF Galleria Rd, Sector 28, DLF
            Phase IV, Gurugram, Haryana 122009.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
